import "./page-eos-sat.scss";
import "../../js/core";
import "../../../assets/src/eos/js/video-youtube-iframe";

$(function () {
  let modal = document.querySelector(".download-detailed-info-with-choose");
  let form = modal.querySelector(".download-detailed-info-with-choose form");
  let messageChecked = modal.getAttribute("data-message-checked");

  if (form) {
    form.addEventListener("wpcf7mailsent", function () {
      let checkboxStatus = form.querySelector(
        '.checkbox-wrap input[type="checkbox"]'
      ).checked;
      let userEmail = form.querySelector('input[name="user-email"]').value;
      messageChecked = messageChecked.replace("XXX", userEmail);

      if (checkboxStatus) {
        $.ajax({
          url: `${location.protocol}//${location.hostname}${
            location.port ? ":" + location.port : ""
          }/wp-admin/admin-ajax.php`,
          type: "POST",
          data: {
            action: "logic_for_download_detailed_info_with_choose",
            user_email: userEmail,
          },
        });
        setTimeout(function () {
          document.querySelector("#modalResponseSent .message").innerHTML =
            messageChecked;
        }, 100);
      }
    });
  }
});
